<template>
<div>
  <!--To top button-->
  <v-btn
    v-scroll="onScroll"
    v-show="fab"
    fab
    dark
    fixed
    bottom
    right
    class="btn-totop"
    @click="toTop"
  >
  <v-icon>mdi-chevron-up</v-icon>
</v-btn>
  <!--/to top button-->
  <!--Banner-->
<div class="bg-banner">
  <v-container>
  <v-row class="justify-space-between py-6 align-center text-white">
    <v-col cols="12" class="text-center text-white"><h3> La App para personal clínico involucrado en la detección de donantes</h3></v-col>
    <v-col cols="5" sm="5" md="3" class="mx-auto">
      <v-img transition="slide-x-transition" src="../assets/img/kefuri-app.png"></v-img>
    </v-col>
    <v-col cols="12" sm="6" md="6">
      <div class="pr-md-16 text-center text-sm-left">
        <h2> DONACIÓN DE ÓRGANOS CON OTROS OJOS </h2>
        <p>Trabajemos juntos para mejorar el procuramiento de órganos</p>
        <p><small>¿Te interesa?</small></p>
        <v-btn href="#contact" depressed color="cyan" dark>
        Contáctanos
        </v-btn>
      </div>
      <div class="mt-5 text-center text-sm-left">
        <p><small>Disponible en: </small></p>
        <v-btn class="mr-3" color="white" outlined href="https://play.google.com/store/apps/details?id=cl.kefuri.app&hl=en_US"> 
          <v-icon class="mr-3">mdi-android</v-icon> <span class="text-white"> ANDROID </span>
        </v-btn>
        <v-btn color="white" outlined href="https://apps.apple.com/cl/app/kefuri/id1460326220">
          <v-icon class="mr-3">mdi-apple</v-icon> APPLE
        </v-btn>
      </div>
    </v-col>  
  </v-row> 
  </v-container> 
</div>
<!--Banner-->
<!--Sobre kefuri-->
  <v-container class="mt-10 mb-5">
  <v-row>
    <v-col cols="12">
      <v-row class="mt-5">
        <v-col cols="12" sm="7" md="6" class="pa-0 mx-auto">
          <img class="rounded img-fluid" src="../assets/banner/banner_xs.png">
        </v-col>
        <v-col cols="12" md="6" class="pa-md-15">
          <h1 class="primary-text mb-3 d-flex d-sm-block justify-center">Sobre el proyecto Kefuri</h1>
          <p class="cuerpo-texto"> Kefuri es un proyecto sin fines de lucro de la Universidad de Chile, con un equipo multidisciplinario de médicos, enfermeras e ingenieros
          que busca formas innovadoras para la mejora de la tasa de <b class="text-red"> donación de órganos en Chile.</b> 
          El nombre viene de la palabra en mapuzungún que significa riñón, ya que los riñones representan cerca del 90% de la lista de espera y de los trasplantes.
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  </v-container>
  <!--Sobre Kefuri-->
  <div class="bg-light py-5">
    <v-container>
      <v-row>
        <v-col md="6" class="">
          <h2 class="text-red mb-3">Línea de investigación</h2>
          <p class="py-0 cuerpo-texto" >El equipo de Kefuri lleva años investigando el sistema de procuramiento y donación de órganos en Chile, con tal de poder entender el problema que afecta la baja tasa de donación del país. Nuestros hallazgos han sido presentados en diversos congresos y revistas científicas, procurando hacer notar el problema del sistema y generar un aporte al área en el país.</p>
          <p> <b>Conóce los eventos y artículos en los que Kefuri <br> ha participado</b> </p>
         
          <v-btn href="/info/#congreso" depressed color="cyan" dark class="mr-6">Congresos</v-btn>
        
          <v-btn href="/info/#articulos" depressed color="cyan" dark>Artículos</v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <img class="rounded img-fluid" src="../assets/img/investigacion.jpg">
        </v-col>
      </v-row>
    </v-container>
  </div>
  <!--/Sobre kefuri-->
  <!--Nuestra APP-->
  <OurApp />
  <!--/Nuestra App-->
  <!--Colaboradores-->
  <SupportUs />
  <!--/Colaboradores-->
  <!-- Contacto -->
  <SocialNetwork />
  <ContactForm/>
</div>
</template>

<script>
// @ is an alias to /src
import OurApp from '../components/OurApp';
import SupportUs from '../components/SupportUs';
import SocialNetwork from '../components/SocialNetwork'
import ContactForm from '../components/ContactForm'

export default {
  name: 'Home',
  components: { OurApp, SupportUs, SocialNetwork, ContactForm },

  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  },
  
  data () {
      return {
        fab: false,
        colors: [
          'indigo',
        ],
        slides: [
          { src: require ('../assets/banner/banner_1.png')},
          ],
        slidesXS: [
          { src: require ('../assets/banner/banner_xs.png')},
          ]
      }
    },
}
</script>

<style lang="sass">
.hr-k
  height: 5px
  width: 10%
  background-color: $primary-hover
  margin-right: auto
  margin-left: auto
  border-width: 0px

.hr-w 
  height: 5px
  width: 10%
  background-color: $white
  margin-right: auto
  margin-left: auto
  border-width: 0px

.cuerpo-texto
  font-size: 1.1rem
  color: $secondary-text

.display-2
  color: red
  p
    font-size: 1.3rem

.carrusel
  display: none
  
  +for-tablet-portrait-up
    display: block

.carrusel-xs
  display: block
  
  +for-tablet-portrait-up
    display: none    
.bg-topred
  margin-bottom: -1px

.bg-banner
  background-image: url('../assets/banner/bg-banner.jpg')
  background-position: center
  height: auto
  background-size: cover

.about-cards
  min-height: 300px
  h4
    font-size: 1.3em
.heart-icon
  height: 100px
  width:100px
  position: absolute
  top: 2%
  right: 10%

.btn-totop
  background-color: $secondary-color !important

</style>